// Candidate markers are validated while scanning: a first marker must start
// after whitespace (or at the beginning), while later markers may directly
// follow a validated one. That recognizes `[1][2]` without treating
// `arr[1][2]` as citations.
import { lastQuoteIn, targetIndexForQuote } from './citationTargetBinding'

const MARKER_RE = /\[(\d+)\]/g

export function segmentCitationText(text, citations = []) {
  if (!text) return []

  const byMarker = new Map()
  citations.forEach((citation, index) => {
    if (typeof citation.marker === 'number') {
      byMarker.set(citation.marker, { citation, index })
    }
  })

  const segments = []
  let lastIndex = 0
  let previousMarkerEnd = -1
  let match

  MARKER_RE.lastIndex = 0
  while ((match = MARKER_RE.exec(text)) !== null) {
    const startsAfterWhitespace = match.index === 0 || /\s/.test(text[match.index - 1])
    const followsMarker = match.index === previousMarkerEnd
    if (!startsAfterWhitespace && !followsMarker) continue

    const marker = Number(match[1])
    const entry = byMarker.get(marker)

    let pre = text.slice(lastIndex, match.index)
    // An unmatched marker has no citation behind it and would render as dead,
    // unclickable text, so drop it — along with a space it would strand.
    if (!entry && pre.endsWith(' ')) pre = pre.slice(0, -1)
    if (pre) segments.push({ type: 'text', value: pre })
    if (entry) {
      segments.push({
        type: 'marker',
        marker,
        citation: entry.citation,
        index: entry.index,
        // Only the window since the previous marker: a claim that dropped its
        // quote must not borrow the previous claim's.
        targetIndex: targetIndexForQuote(entry.citation, lastQuoteIn(text.slice(lastIndex, match.index))),
      })
    }
    lastIndex = match.index + match[0].length
    previousMarkerEnd = lastIndex
  }

  if (lastIndex < text.length) {
    segments.push({ type: 'text', value: text.slice(lastIndex) })
  }
  return segments
}
